import { LOADING_STATUS } from "@/helpers/loadingStatus";
import httpClient from "@/http/httpClient";
import store from "@/store";
import _ from "lodash";
const module = {
  namespaced: true,
  state: () => {
    return {
      //Configs
      showGroupBy: true,
      showDealerSelection: true,
      //
      loadingStatus: "",
      result: [],
      selectedDealers: [],
      groupBy: "none", //none,dealer,suburb
      search: "",
      sortBy: "name",
      availableItemsPerPageOptions: [10, 20, 50, 100],
      itemsPerPage: 10,
      currentPage: 1,
      hasMorePages: false,
      availableSortFields: ["name"],
      selectedSort: {
        field: "name",
        direction: "asc",
      },
    };
  },
  getters: {
    hasNextPage(state) {
      return state.hasMorePages; //state.totalPages > state.currentPage;
    },
    getParams(state) {
      const params = {};
      if (state.selectedDealers.length) {
        params["filter[dealer_id]"] = state.selectedDealers
          .map((x) => x.id)
          .join(",");
      }

      if (state.search.toString().trim()) {
        params["filter[search]"] = state.search.toString().trim();
      }

      if (state.groupBy && state.groupBy !== "none") {
        params["group_by"] = state.groupBy;
      }

      params["sort"] = `${state.selectedSort.direction === "desc" ? "-" : ""}${
        state.selectedSort.field
      }`;

      if (state.groupBy === "none") {
        params["paginate"] = state.itemsPerPage;
        params["page"] = state.currentPage;
      }

      return params;
    },
  },
  mutations: {
    setShowDealerSelection(state, payload) {
      state.showDealerSelection = payload;
    },
    setShowGroupBy(state, payload) {
      state.showGroupBy = payload;
    },
    reset(state) {
      state.currentPage = 1;
      state.result = [];
    },
    setSelectedDealers(state, payload) {
      state.currentPage = 1;
      state.result = [];
      state.selectedDealers = payload;
    },
    setGroupBy(state, payload) {
      state.result = payload !== "none" ? {} : [];
      state.currentPage = 1;
      state.groupBy = payload;
    },
    setItemsPerPage(state, payload) {
      state.currentPage = 1;
      state.result = [];
      state.itemsPerPage = payload;
    },
    setSearchTerm(state, payload) {
      state.currentPage = 1;
      state.result = [];
      state.search = payload;
    },
    setSortBy(state, payload) {
      state.currentPage = 1;
      state.result = [];
      state.selectedSort = payload;
      // state.sortBy =
      //   state.sortBy === payload
      //     ? state.sortBy[0] === "-"
      //       ? state.sortBy.subStr(0)
      //       : `-${payload}`
      //     : payload;
    },
    setLoadingStatus(state, payload) {
      state.loadingStatus = payload;
    },
    loadNextPage(state, payload) {
      state.currentPage = state.currentPage + 1;
    },
    setHasMorePages(state, payload) {
      const result = _.get(payload, "has_more_pages", false);
      state.hasMorePages = result;
    },
    setResult(state, payload) {
      if (state.groupBy === "none") {
        state.result = [...state.result, ...payload];
      } else {
        state.result = payload;
      }
    },
  },
  actions: {
    async fetchCustomerById({ commit, state, dispatch, getters }, customerId) {
      try {
        const response = httpClient.get(`customers/${customerId}`);
        return response;
      } catch (error) {
        store.commit("errorsModal/openModal", error.response.data.errors);
        return false;
      }
    },
    async fetchOrdersForCustomer(
      { commit, state, dispatch, getters },
      { customerId, params }
    ) {
      try {
        const response = httpClient.get(`customers/${customerId}/orders`, {
          params: params,
        });
        return response;
      } catch (error) {
        store.commit("errorsModal/openModal", error.response.data.errors);
        return false;
      }
    },
    async fetchAllWithFilters({ commit, state, dispatch, getters }) {
      if (
        [LOADING_STATUS.REFRESHING, LOADING_STATUS.FETCHING].includes(
          state.loadingStatus
        )
      ) {
        return true;
      }

      commit(
        "setLoadingStatus",
        !_.isEmpty(state.result)
          ? LOADING_STATUS.REFRESHING
          : LOADING_STATUS.FETCHING
      );
      try {
        const response = await httpClient.get("customers", {
          params: getters.getParams,
        });
        commit("setResult", response.data.data);
        commit("setHasMorePages", response.data.pagination);
        setTimeout(() => {
          commit("setLoadingStatus", LOADING_STATUS.COMPLETED);
        });
        return true;
      } catch (error) {
        console.error("Error on Fetch customer: ", error);
        commit("setLoadingStatus", LOADING_STATUS.FAILED);
        store.commit("errorsModal/openModal", error.response.data.errors);
        return false;
      }
    },
  },
};

export const NAMESPACES = {
  CUSTOMERS_MODULE_FOR_DEALERS_MAINTANANCE:
    "customersModuleForDealersMaintanance",
};

export const registerModule = (namespace) => {
  if (!store.hasModule(namespace)) store.registerModule(namespace, module);
};

export const unregisterModule = (namespace) => {
  if (store.hasModule(namespace)) store.unregisterModule(namespace);
};

export default module;
